import Container from 'react-bootstrap/Container';
import logo from './logo.png';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import { House, Newspaper, Projector, Info, MailOpen, UserRoundPlus, Megaphone, Archive, Calendar, KeyRound } from 'lucide-react';

function NavBar() {
  return (
    <>
        <Navbar expand="xxl" variant='main'>
      <Container style={{ display: "flex", alignItems: "center" }}>
          <Navbar.Brand href="/#"><img src={logo} alt="Logo" width="auto" height="70" /></Navbar.Brand>
          <Navbar.Brand href="/#" style={{ overflowX: "auto"}}><p style={{ marginBottom: 0, width: "100%", maxWidth: "40vw", overflowX: "auto"}}>{process.env.REACT_APP_NAME}</p></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="/#" style={{ display: "flex", alignItems: "center", flexDirection: "row", alignContent: "center" }}><House size={20} />&nbsp;<span>Főoldal</span></Nav.Link>
              <Nav.Link href="/#hirek/1" style={{ display: "flex", alignItems: "center", flexDirection: "row", alignContent: "center" }}><Newspaper size={20} />&nbsp;<span>Hírek</span></Nav.Link>
              <Nav.Link href="/#projektek" style={{ display: "flex", alignItems: "center", flexDirection: "row", alignContent: "center" }}><Projector size={20} />&nbsp;<span>Projektek</span></Nav.Link>
              <Nav.Link href="/#rolunk" style={{ display: "flex", alignItems: "center", flexDirection: "row", alignContent: "center" }}><Info size={20} />&nbsp;<span>Rólunk</span></Nav.Link>
              <Nav.Link href="/#tagfelvetel" style={{ display: "flex", alignItems: "center", flexDirection: "row", alignContent: "center" }}><UserRoundPlus size={20} />&nbsp;<span>Tagfelvétel</span></Nav.Link>
              <Nav.Link href="/#kapcsolat" style={{ display: "flex", alignItems: "center", flexDirection: "row", alignContent: "center" }}><MailOpen size={20} />&nbsp;<span>Kapcsolat</span></Nav.Link>
              <Nav.Link href='/#hirlevel' style={{ display: "flex", alignItems: "center", flexDirection: "row", alignContent: "center" }}><Megaphone size={20} />&nbsp;<span>Hírlevél</span></Nav.Link>
              <Nav.Link href={process.env.REACT_APP_EVENT_PB_FRONTEND_URL} style={{ display: "flex", alignItems: "center", flexDirection: "row", alignContent: "center" }}><Calendar size={20} />&nbsp;<span>Rendezvények</span><EventNotificationBubble /></Nav.Link>
          <Navbar.Text>
            <Button variant="outline-dark" href={`${process.env.REACT_APP_HEADLESS_WP_URL}/wp-admin`} style={{ display: "flex", alignItems: "center", width: "fit-content" }}><KeyRound size={20} /> &nbsp;Belépés</Button>
          </Navbar.Text>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}


function EventNotificationBubble() {

  const [ eventNumber, setEventNumber ] = useState(null)
  
  useEffect(() => {
    fetch(process.env.REACT_APP_EVENT_PB_URL + "/api/collections/rendezvenyek/records?page=1&perPage=50&filter=status%3D%22Nyitott%22",
      {
        method: "GET"
      }
    ).then((data) => data.json())
    .then((data) => {
      if (data.totalItems) {
        setEventNumber(data.totalItems)
      } else {
        setEventNumber(0)
      }
    })
  //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (eventNumber === null || eventNumber === 0) {
    return null;
  }

  return (
    <Badge pill style={{ marginLeft: 5, display: 'inline' }} bg='dark'>{eventNumber}</Badge>
  )
}

export default NavBar;